<script setup lang="ts">
import {
  PartStatusTagTypes,
  PartStatusIcons,
  PartStatusBadgeBgColor,
  PartStatus,
  PartDiagnosticStatus,
} from '@/types/rc/miners/PartStatus'
import { Icon } from '@iconify/vue'
defineProps<{
  status: PartStatus | PartDiagnosticStatus | null
}>()
</script>

<template>
  <el-tag
    :disable-transitions="true"
    :type="PartStatusTagTypes[status ?? PartStatus.RepairNotAuthorized]"
    :class="`bg-${PartStatusBadgeBgColor[status ?? PartStatus.RepairNotAuthorized]}`"
  >
    <div class="flex flex-row items-center gap-1 text-xs">
      <icon :height="20" :icon="status ? PartStatusIcons[status] : 'mdi:horizontal-line'" />
      <span>{{ status ?? 'Not set' }}</span>
    </div>
  </el-tag>
</template>
